<div class="filter">
  <span class="title">{{ title }}</span>
  <div *ngFor="let range of filterRangeList; index as i">
    <label [ngClass]="{ yellow: range.from + 1 < 0 }">
      {{ formatRange(range) }}
    </label>
    <div [ngClass]="{ 'filter-active': activeIndex === i }" class="highlight-range-{{ i }}" (click)="onClick(range, i)"></div>
  </div>
</div>
